module.exports = "<div [style.display]=\"showMask?'block':'none'\" class=\"dwDivMask\" #maskDiv [ngStyle]=\"customStyle\"></div>"